export const TYPE_LABELS = { BUG: 'Błąd', FEATURE: 'Nowa funkcja', CHANGE: 'Zmiana' };
export const STATUS_LABELS = { NEW: 'Nowe', IN_ANALYSIS: 'W analizie', PLANNED: 'Zaplanowane', IN_PROGRESS: 'W realizacji', RESOLVED: 'Rozwiązane', REJECTED: 'Odrzucone', CLOSED: 'Zamknięte' };
export function requestId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes).map(value => value.toString(16).padStart(2, '0')).join('');
}
